import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Box, Grid, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';
import React from 'react';
import { OPACITY_SELECTED } from 'theme/muiTheme';

interface Props {
  id?: string;
  label: string;
  statusLabel: string;
  statusColor: 'success' | 'error';
  isExpandable: boolean;
  isOpen: boolean;
  onToggle: () => void;
}

const MobileAppRowHeader: React.FC<Props> = ({
  id,
  label,
  statusLabel,
  statusColor,
  isExpandable,
  isOpen,
  onToggle
}) => {
  const statusChip = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        height: 24,
        borderRadius: 12,
        paddingX: 1.25,
        flexShrink: 0,
        backgroundColor: (theme) => theme.alpha(theme.palette[statusColor].main, OPACITY_SELECTED)
      }}
    >
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: `${statusColor}.main`, flexShrink: 0 }} />
      <Typography variant="body2" sx={{ color: `${statusColor}.main`, whiteSpace: 'nowrap' }}>
        {statusLabel}
      </Typography>
    </Box>
  );

  return (
    <ListItemButton
      id={id}
      onClick={isExpandable ? onToggle : undefined}
      disableRipple={!isExpandable}
      sx={{
        gap: 1,
        alignItems: 'center',
        backgroundColor: (theme) => theme.custom.background.level2,
        borderRadius: 1,
        cursor: isExpandable ? 'pointer' : 'default',
        ...(!isExpandable && { '&:hover': { backgroundColor: (theme) => theme.custom.background.level2 } })
      }}
    >
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="space-between"
        alignItems="center"
        flex={1}
        minWidth={0}
        rowGap={0.5}
        columnGap={1}
      >
        <Box minWidth={0} overflow="hidden">
          <ListItemText
            primary={label}
            slotProps={{
              primary: {
                variant: 'body1',
                noWrap: true
              }
            }}
          />
        </Box>
        {statusChip}
      </Stack>
      <Grid sx={{ display: 'flex', alignItems: 'center' }}>
        {isOpen ? (
          <ExpandLess sx={{ visibility: isExpandable ? 'visible' : 'hidden' }} />
        ) : (
          <ExpandMore sx={{ visibility: isExpandable ? 'visible' : 'hidden' }} />
        )}
      </Grid>
    </ListItemButton>
  );
};

export default MobileAppRowHeader;
